function hexToRgb(hex) {
  return [
    Number.parseInt(hex.slice(1, 3), 16),
    Number.parseInt(hex.slice(3, 5), 16),
    Number.parseInt(hex.slice(5, 7), 16),
  ];
}

const HEAT_SENSITIVITY = 0.7;

/*
 * Opacity progression by bucket.
 *
 * Bucket 1 = faint
 * Bucket 10 = fully opaque
 */
// const BOOKMAP_HEAT_ALPHA = [
//   0.20,
//   0.28,
//   0.36,
//   0.45,
//   0.55,
//   0.65,
//   0.75,
//   0.84,
//   0.92,
//   1.00,
// ];

const BOOKMAP_HEAT_ALPHA = [
  0.05, // 5%
  0.12,
  0.20,
  0.30,
  0.42,
  0.55,
  0.68,
  0.80,
  0.90,
  1.00,
];

const BOOKMAP_HEAT_PALETTES = {
  volume: {
    neutral: '#000000',

    positive: [
      '#2f7462',
      '#2f8668',
      '#2b9874',
      '#25aa82',
      '#1fbc93',
      '#18cda7',
      '#12dcbc',
      '#10e7d2',
      '#17e9e8',
      '#35bfff',
    ],

    negative: [
      '#4a527f',
      '#5e4f91',
      '#744a9d',
      '#8c439f',
      '#a63b9b',
      '#bf338f',
      '#d72b7e',
      '#e82968',
      '#f12d4f',
      '#ff3b27',
    ],
  },

  delta: {
    neutral: '#000000',

    positive: [
      '#65528f',
      '#685ca3',
      '#6769b8',
      '#6078cb',
      '#5689dc',
      '#479be9',
      '#36adf2',
      '#25c0f5',
      '#19d3ef',
      '#16eadc',
    ],

    negative: [
      '#fff45a',
      '#ffe63a',
      '#ffd922',
      '#ffca0b',
      '#ffb900',
      '#ffa000',
      '#ff8500',
      '#ff6800',
      '#f94c12',
      '#e85b16',
    ],
  },

  gamma: {
    neutral: '#000000',

    positive: [
      '#596487',
      '#4d759a',
      '#3988ab',
      '#229bb5',
      '#10adba',
      '#08c0b8',
      '#0bd2ae',
      '#16e39b',
      '#31ef73',
      '#73ff3e',
    ],

    negative: [
      '#f1c62c',
      '#f7b928',
      '#f9aa25',
      '#f89a22',
      '#f68920',
      '#f37720',
      '#f06422',
      '#ef5029',
      '#f13b3a',
      '#ff3859',
    ],
  },
};


// const BOOKMAP_HEAT_PALETTES = {
//   volume: {
//     neutral: '#000000',
//
//     positive: [
//       '#000000',
//       '#000405',
//       '#00181b',
//       '#013136',
//       '#014c54',
//       '#026973',
//       '#048794',
//       '#07a7b6',
//       '#0ac8da',
//       '#0eeaff',
//     ],
//
//     negative: [
//       '#000000',
//       '#050000',
//       '#1b0100',
//       '#360201',
//       '#540501',
//       '#730902',
//       '#941004',
//       '#b61607',
//       '#da1c0a',
//       '#ff230e',
//     ],
//   },
//
//   delta: {
//     neutral: '#000000',
//
//     positive: [
//       '#000000',
//       '#000303',
//       '#021614',
//       '#062e2a',
//       '#0e4843',
//       '#17645c',
//       '#218178',
//       '#2ba094',
//       '#35bfb2',
//       '#40e0d0',
//     ],
//
//     negative: [
//       '#000000',
//       '#030000',
//       '#130300',
//       '#290b00',
//       '#411600',
//       '#5b2100',
//       '#752e00',
//       '#913a00',
//       '#ae4700',
//       '#cc5500',
//     ],
//   },
//
//   gamma: {
//     neutral: '#000000',
//
//     positive: [
//       '#000000',
//       '#000004',
//       '#000019',
//       '#010132',
//       '#02014e',
//       '#04036c',
//       '#07058b',
//       '#0c08ac',
//       '#100ccd',
//       '#1510f0',
//     ],
//
//     negative: [
//       '#000000',
//       '#050200',
//       '#1b1100',
//       '#362600',
//       '#543d00',
//       '#735500',
//       '#946e00',
//       '#b68800',
//       '#daa400',
//       '#ffc000',
//     ],
//   },
// };


/*
 * Legacy PRO palette.
 *
 * This is retained so any older/non-Bookmap component using
 * paletteName="pro" continues to function.
 */
const PRO_PALETTE = {
  neutral: [18, 24, 30],

  red: [
    [78, 23, 26],
    [124, 31, 34],
    [204, 43, 47],
    [248, 72, 75],
  ],

  green: [
    [12, 47, 30],
    [20, 82, 47],
    [28, 145, 70],
    [51, 205, 92],
  ],

  neutralCut: 0.18,
};


function clamp(value, min, max) {
  return Math.max(min, Math.min(max, value));
}


function normalizeLayer(layer) {
  if (layer === 'g') return 'gamma';
  if (layer === 'd') return 'delta';
  if (layer === 'vol') return 'volume';

  if (BOOKMAP_HEAT_PALETTES[layer]) {
    return layer;
  }

  return 'gamma';
}


export function rgbTuple(tuple, alpha = 1) {
  return `rgba(${tuple[0]},${tuple[1]},${tuple[2]},${alpha})`;
}


/*
 * BOOKMAP COLOR MAPPING
 *
 * bucketNormalizedValue() already gives us:
 *
 *   0.0 = neutral
 *   0.1 = bucket 1
 *   0.2 = bucket 2
 *   ...
 *   1.0 = bucket 10
 *
 * Negative values use the negative palette.
 * Positive values use the positive palette.
 *
 * There is intentionally NO interpolation or dynamic
 * normalization here.
 *
 * Each bucket has both:
 *   1. A defined RGB color
 *   2. A defined opacity level
 *
 * Lower buckets are more transparent.
 * Higher buckets progressively become fully opaque.
 */
function bookmapLayerBandColor(value, layer = 'gamma') {
  const normalizedLayer = normalizeLayer(layer);
  const palette = BOOKMAP_HEAT_PALETTES[normalizedLayer];

  const numericValue = Number(value);

  if (!Number.isFinite(numericValue) || numericValue === 0) {
    return {
      rgb: hexToRgb(palette.neutral),
      alpha: 1,
    };
  }

  let magnitude = clamp(Math.abs(numericValue), 0, 1);

  /*
   * Amplify lower bucket values before assigning
   * the final 1-10 heat bucket.
   */
  magnitude = Math.pow(magnitude, HEAT_SENSITIVITY);

  /*
   * Convert:
   *
   * 0.1 -> index 0
   * 0.2 -> index 1
   * ...
   * 1.0 -> index 9
   */
  const bucket = clamp(
    Math.round(magnitude * 10),
    1,
    10
  );

  const index = bucket - 1;

  const bands = numericValue > 0
    ? palette.positive
    : palette.negative;

  const hex = bands[index] || palette.neutral;

  return {
    rgb: hexToRgb(hex),
    alpha: BOOKMAP_HEAT_ALPHA[index] ?? 1,
  };
}


/*
 * Legacy PRO mapping.
 *
 * The old square-root behavior is retained ONLY for the
 * legacy "pro" palette. It is NOT used by the Bookmap
 * heatmap.
 */
function proBandColor(value) {
  const numericValue = Number(value);

  if (!Number.isFinite(numericValue)) {
    return {
      rgb: PRO_PALETTE.neutral,
      alpha: 0.45,
    };
  }

  const t = Math.sqrt(
    Math.min(1, Math.abs(numericValue))
  );

  if (t < PRO_PALETTE.neutralCut) {
    return {
      rgb: PRO_PALETTE.neutral,
      alpha: 0.45,
    };
  }

  const bands = numericValue >= 0
    ? PRO_PALETTE.green
    : PRO_PALETTE.red;

  const index =
    t < 0.42
      ? 0
      : t < 0.64
        ? 1
        : t < 0.84
          ? 2
          : 3;

  return {
    rgb:
      bands[index]
      || bands[bands.length - 1]
      || PRO_PALETTE.neutral,

    alpha: 0.28 + t * 0.62,
  };
}


export function bookmapHeatBandColor(
  value,
  paletteName = 'bookmap',
  layer = 'gamma'
) {
  if (paletteName === 'bookmap') {
    return bookmapLayerBandColor(
      value,
      layer
    );
  }

  return proBandColor(value);
}


export function bookmapHeatCssColor(
  value,
  paletteName = 'bookmap',
  layer = 'gamma'
) {
  const { rgb, alpha } = bookmapHeatBandColor(
    value,
    paletteName,
    layer
  );

  return rgbTuple(rgb, alpha);
}









// function hexToRgb(hex) {
//   return [
//     Number.parseInt(hex.slice(1, 3), 16),
//     Number.parseInt(hex.slice(3, 5), 16),
//     Number.parseInt(hex.slice(5, 7), 16),
//   ];
// }
//
// const HEAT_SENSITIVITY = 0.7;
//
// const BOOKMAP_HEAT_PALETTES = {
//   volume: {
//     neutral: '#000000',
//
//     positive: [
//       '#2f7462',
//       '#2f8668',
//       '#2b9874',
//       '#25aa82',
//       '#1fbc93',
//       '#18cda7',
//       '#12dcbc',
//       '#10e7d2',
//       '#17e9e8',
//       '#35bfff'
//     ],
//
//     negative: [
//       '#4a527f',
//       '#5e4f91',
//       '#744a9d',
//       '#8c439f',
//       '#a63b9b',
//       '#bf338f',
//       '#d72b7e',
//       '#e82968',
//       '#f12d4f',
//       '#ff3b27'
//     ],
//   },
//
//   delta: {
//     neutral: '#000000',
//
//     positive: [
//       '#65528f',
//       '#685ca3',
//       '#6769b8',
//       '#6078cb',
//       '#5689dc',
//       '#479be9',
//       '#36adf2',
//       '#25c0f5',
//       '#19d3ef',
//       '#16eadc'
//     ],
//
//     negative: [
//       '#fff45a',
//       '#ffe63a',
//       '#ffd922',
//       '#ffca0b',
//       '#ffb900',
//       '#ffa000',
//       '#ff8500',
//       '#ff6800',
//       '#f94c12',
//       '#e85b16'
//     ],
//   },
//
//   gamma: {
//     neutral: '#000000',
//
//     positive: [
//       '#596487',
//       '#4d759a',
//       '#3988ab',
//       '#229bb5',
//       '#10adba',
//       '#08c0b8',
//       '#0bd2ae',
//       '#16e39b',
//       '#31ef73',
//       '#73ff3e'
//     ],
//
//     negative: [
//       '#f1c62c',
//       '#f7b928',
//       '#f9aa25',
//       '#f89a22',
//       '#f68920',
//       '#f37720',
//       '#f06422',
//       '#ef5029',
//       '#f13b3a',
//       '#ff3859'
//     ],
//   },
// };
//
// // const BOOKMAP_HEAT_PALETTES = {
// //   volume: {
// //     neutral: '#000000',
// //
// //     positive: [
// //       '#000000',
// //       '#000405',
// //       '#00181b',
// //       '#013136',
// //       '#014c54',
// //       '#026973',
// //       '#048794',
// //       '#07a7b6',
// //       '#0ac8da',
// //       '#0eeaff',
// //     ],
// //
// //     negative: [
// //       '#000000',
// //       '#050000',
// //       '#1b0100',
// //       '#360201',
// //       '#540501',
// //       '#730902',
// //       '#941004',
// //       '#b61607',
// //       '#da1c0a',
// //       '#ff230e',
// //     ],
// //   },
// //
// //   delta: {
// //     neutral: '#000000',
// //
// //     positive: [
// //       '#000000',
// //       '#000303',
// //       '#021614',
// //       '#062e2a',
// //       '#0e4843',
// //       '#17645c',
// //       '#218178',
// //       '#2ba094',
// //       '#35bfb2',
// //       '#40e0d0',
// //     ],
// //
// //     negative: [
// //       '#000000',
// //       '#030000',
// //       '#130300',
// //       '#290b00',
// //       '#411600',
// //       '#5b2100',
// //       '#752e00',
// //       '#913a00',
// //       '#ae4700',
// //       '#cc5500',
// //     ],
// //   },
// //
// //   gamma: {
// //     neutral: '#000000',
// //
// //     positive: [
// //       '#000000',
// //       '#000004',
// //       '#000019',
// //       '#010132',
// //       '#02014e',
// //       '#04036c',
// //       '#07058b',
// //       '#0c08ac',
// //       '#100ccd',
// //       '#1510f0',
// //     ],
// //
// //     negative: [
// //
// //       '#000000',
// //       '#050200',
// //       '#1b1100',
// //       '#362600',
// //       '#543d00',
// //       '#735500',
// //       '#946e00',
// //       '#b68800',
// //       '#daa400',
// //       '#ffc000',
// //     ],
// //   },
// // };
//
//
// /*
//  * Legacy PRO palette.
//  *
//  * This is retained so any older/non-Bookmap component using
//  * paletteName="pro" continues to function.
//  */
// const PRO_PALETTE = {
//   neutral: [18, 24, 30],
//
//   red: [
//     [78, 23, 26],
//     [124, 31, 34],
//     [204, 43, 47],
//     [248, 72, 75],
//   ],
//
//   green: [
//     [12, 47, 30],
//     [20, 82, 47],
//     [28, 145, 70],
//     [51, 205, 92],
//   ],
//
//   neutralCut: 0.18,
// };
//
//
// function clamp(value, min, max) {
//   return Math.max(min, Math.min(max, value));
// }
//
//
// function normalizeLayer(layer) {
//   if (layer === 'g') return 'gamma';
//   if (layer === 'd') return 'delta';
//   if (layer === 'vol') return 'volume';
//
//   if (BOOKMAP_HEAT_PALETTES[layer]) {
//     return layer;
//   }
//
//   return 'gamma';
// }
//
//
// export function rgbTuple(tuple, alpha = 1) {
//   return `rgba(${tuple[0]},${tuple[1]},${tuple[2]},${alpha})`;
// }
//
//
// /*
//  * BOOKMAP COLOR MAPPING
//  *
//  * bucketNormalizedValue() already gives us:
//  *
//  *   0.0 = neutral
//  *   0.1 = bucket 1
//  *   0.2 = bucket 2
//  *   ...
//  *   1.0 = bucket 10
//  *
//  * Negative values use the negative palette.
//  * Positive values use the positive palette.
//  *
//  * There is intentionally NO square-root transformation,
//  * interpolation, or dynamic normalization here.
//  *
//  * Bucket 1 is intentionally #000000 for every palette.
//  */
// function bookmapLayerBandColor(value, layer = 'gamma') {
//   const normalizedLayer = normalizeLayer(layer);
//   const palette = BOOKMAP_HEAT_PALETTES[normalizedLayer];
//
//   const numericValue = Number(value);
//
//   if (!Number.isFinite(numericValue) || numericValue === 0) {
//     return {
//       rgb: hexToRgb(palette.neutral),
//       alpha: 1,
//     };
//   }
//
//   let magnitude = clamp(Math.abs(numericValue), 0, 1);
//
//   // OPTIONAL: amplify lower buckets.
//   // Comment this line out to use direct 1–10 bucket mapping.
//   magnitude = Math.pow(magnitude, HEAT_SENSITIVITY);
//
//   /*
//    * Convert:
//    *
//    * 0.1 -> index 0
//    * 0.2 -> index 1
//    * ...
//    * 1.0 -> index 9
//    *
//    * Math.round is intentional because the incoming values
//    * are discrete 0.1 bucket increments.
//    */
//   const bucket = clamp(
//     Math.round(magnitude * 10),
//     1,
//     10
//   );
//
//   const index = bucket - 1;
//
//   const bands = numericValue > 0
//     ? palette.positive
//     : palette.negative;
//
//   const hex = bands[index] || palette.neutral;
//
//   return {
//     rgb: hexToRgb(hex),
//
//     /*
//      * Alpha 1 preserves the exact colors supplied in the
//      * palette against the black Bookmap background.
//      */
//     alpha: 1,
//   };
// }
//
//
// /*
//  * Legacy PRO mapping.
//  *
//  * The old square-root behavior is retained ONLY for the
//  * legacy "pro" palette. It is NOT used by the Bookmap
//  * heatmap.
//  */
// function proBandColor(value) {
//   const numericValue = Number(value);
//
//   if (!Number.isFinite(numericValue)) {
//     return {
//       rgb: PRO_PALETTE.neutral,
//       alpha: 0.45,
//     };
//   }
//
//   const t = Math.sqrt(
//     Math.min(1, Math.abs(numericValue))
//   );
//
//   if (t < PRO_PALETTE.neutralCut) {
//     return {
//       rgb: PRO_PALETTE.neutral,
//       alpha: 0.45,
//     };
//   }
//
//   const bands = numericValue >= 0
//     ? PRO_PALETTE.green
//     : PRO_PALETTE.red;
//
//   const index =
//     t < 0.42
//       ? 0
//       : t < 0.64
//         ? 1
//         : t < 0.84
//           ? 2
//           : 3;
//
//   return {
//     rgb:
//       bands[index]
//       || bands[bands.length - 1]
//       || PRO_PALETTE.neutral,
//
//     alpha: 0.28 + t * 0.62,
//   };
// }
//
//
// export function bookmapHeatBandColor(
//   value,
//   paletteName = 'bookmap',
//   layer = 'gamma'
// ) {
//   if (paletteName === 'bookmap') {
//     return bookmapLayerBandColor(
//       value,
//       layer
//     );
//   }
//
//   return proBandColor(value);
// }
//
//
// export function bookmapHeatCssColor(
//   value,
//   paletteName = 'bookmap',
//   layer = 'gamma'
// ) {
//   const { rgb, alpha } = bookmapHeatBandColor(
//     value,
//     paletteName,
//     layer
//   );
//
//   return rgbTuple(rgb, alpha);
// }
